import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import { MatchResultsForUser } from '@fantaz/shared/data-access/models';

import * as GameHistoryActions from './game-history.actions';

export const GAME_HISTORY_FEATURE_KEY = 'gameHistory';

export interface GameHistoryState extends EntityState<MatchResultsForUser> {
  selectedId?: string | number; // which GameHistory record has been selected
  loaded: boolean; // has the GameHistory list been loaded
  total: number; // has the GameHistory list been loaded
  error?: string | null; // last known error (if any)
}

export interface GameHistoryPartialState {
  readonly [GAME_HISTORY_FEATURE_KEY]: GameHistoryState;
}

export const gameHistoryAdapter: EntityAdapter<MatchResultsForUser> =
  createEntityAdapter<MatchResultsForUser>({
    selectId: (gameHistory: MatchResultsForUser) =>
      gameHistory.playInstanceUuid,
  });

export const gameHistoryInitialState: GameHistoryState =
  gameHistoryAdapter.getInitialState({
    // set initial required properties
    loaded: false,
    total: 0,
  });

const reducer = createReducer(
  gameHistoryInitialState,
  on(GameHistoryActions.loadGameHistory, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(GameHistoryActions.loadGameHistorySuccess, (state, { gameHistory }) =>
    gameHistoryAdapter.setAll(gameHistory.matchResultsForUser, {
      ...state,
      loaded: true,
      total: gameHistory.total,
    }),
  ),
  on(GameHistoryActions.loadGameHistoryFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(GameHistoryActions.clearGameHistory, (state) => ({
    ...state,
    loaded: false,
    error: null,
    details: null,
  })),
);

export function gameHistoryReducer(
  state: GameHistoryState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
